<form>
  <xena-table>
      <xena-column width="10%"></xena-column>
      <xena-column width="40%"  i18n="@@import_csv_imported_user_name">Imported employee</xena-column>
      <xena-column width="50%" i18n="@@import_csv_xena_resource">Xena resource</xena-column>
      <xena-row *ngFor="let mapping of resourceMappings.controls" [formGroup]="mapping">
        <xena-cell>
          <xena-checkbox formControlName="selected"></xena-checkbox>
        </xena-cell>
        <xena-cell>
          {{ mapping.get('employeeName').value + ' ('+ mapping.get('employeeId').value + ')' }}
        </xena-cell>
        <xena-cell>
          <xena-autocomplete
            idProperty="id"
            [datasource]="resourcesDatasource"
            formControlName="resource"
            listLabelProperty="name"
            valueLabelProperty="name"
            debounce="300"
            show-initial-no-result="false"
            no-result-text="No results"
            i18n-no-result-text="@@import_csv_resource_noResult" hoist>
            <span slot="error-text" *ngIf="mapping.touched && mapping.errors?.['requiredWhenSelected']" i18n="@@import_csv_Resource_Required">Resource required</span>
          </xena-autocomplete>
        </xena-cell>
      </xena-row>
  </xena-table>
</form>
